import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Tooltip,
  SvgIcon
} from '@material-ui/core';
import { DialogWithFocusProvider } from 'components/layout';
import { Stack, LoadingOverlayWrapper } from 'components/layout';
import {
  fetchExplorePropertyUnderwrites,
	setIsFetchingPropertyUWHistory
} from 'store/actions';
import { Scrolling, Column } from "devextreme-react/data-grid";
import DataGrid from 'components/devExtreme/DataGrid';

const ViewUnderwriteModal = ({ classes, anchorEl, open, handleChangeUnderwrite, onClose, asgPropID,
  fetchExplorePropertyUnderwrites, propertyUnderwritesData, isFetchingPropertyUWHistory
}) => {
  useEffect(() => {
    if (!open) return;
    let abortController = new AbortController();

    fetchExplorePropertyUnderwrites(asgPropID, false);

    return () => {
      abortController.abort();
    }
  }, [open]);

  const applyColumnRender = (e) => {
    return (
      <Stack horizontal>
        <Tooltip title={"Apply"} placement="bottom">
          <SvgIcon
            onClick={() => {
              handleChangeUnderwrite(e);
            }}
            className={classes.btnApply}
          >
            <path d="M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z" />
          </SvgIcon>
        </Tooltip>
      </Stack>
    );
  };

	return (
		<DialogWithFocusProvider
			variant='popover'
			open={open}
			anchorEl={anchorEl}
			onClose={onClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
		>
			<div className={classes.popoverContainer}>
				<div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
					<Typography variant="subtitle1" style={{ zIndex: 1, paddingTop: 4 }}>Underwrite History</Typography>
				</div>
				<LoadingOverlayWrapper
					active={isFetchingPropertyUWHistory}
					message={'Loading underwrites...'}
				>
					<DataGrid
						keyExpr={'id'}
						persistState
						dataSource={propertyUnderwritesData}
						height={300}
						paging={{ enabled: false }}
						hoverStateEnabled
						allowColumnResizing={true}
					>
						<Column width={48} cellRender={applyColumnRender} />
						<Column dataField={"module"} width={75} />
						<Column dataField={"id"} caption="ID" width={95} />
						<Column dataField={"createdOn"} dataType={"date"} sortOrder={"desc"} format={"MM/dd/yyyy"} width={120} />
						<Column dataField={"status"} width={120} />
						<Column dataField={"underwriteStatus"} caption='UW Status' width={120} />
						<Column dataField={"user"} caption='Saved By' />
						<Column dataField={"type"} width={130} allowFiltering={true} />
						<Scrolling
							rowRenderingMode='virtual'
						/>
					</DataGrid>
				</LoadingOverlayWrapper>
			</div>
		</DialogWithFocusProvider>
	)
}

const styles = theme => ({
  popoverContainer: {
    padding: 8,
    width: 920
  },
  btnApply: {
    padding: 2,
    background: "rgba(0, 0, 0, 0.1)",
    borderRadius: `5px`,
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      cursor: `pointer`,
    },
  }
});

const mapState = ({ exploreData }) => {
  return {
    propertyUnderwritesData: exploreData.propertyUnderwritesData,
		isFetchingPropertyUWHistory: exploreData.isFetchingPropertyUWHistory
  }
};
const mapDispatch = {
  fetchExplorePropertyUnderwrites,
	setIsFetchingPropertyUWHistory
};

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(ViewUnderwriteModal);